import { useContext } from "react";
import DruidWebchatContext, { DruidWebchatContextType } from "../WebChatContext";
import { WebChatOptions } from "../WebChatOptions";


export function useMergedOptions(): WebChatOptions {
    const [druidWebChatState,] = useContext<DruidWebchatContextType>(DruidWebchatContext);
    return druidWebChatState.mergedChatOptions;
}